export default "https://cdn-static.gokick.com/assets/28dce4dd80241a45018c00057f67470c3fae89ba/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";